@if (slide) {
  <div class="d-flex flex-column caption-content {{ slide.color }} {{ slide.position }}">
    @if (slide.logo) {
      <div class="logo">
        @if (slide.logo == 1068) {
          <img src="assets/gea-stroke-black.png" />
        }
        @if (slide.logo == 1153) {
          <img src="assets/gea-stroke-white.png" />
        }
      </div>
    }
    @if (slide.link_url && slide.link_text) {
      <a class="btn btn-primary" href="{{ slide.link_url }}">{{ slide.link_text }}</a>
    }
    @if (slide.row_1) {
      <span class="row1">{{ slide.row_1 }}</span>
    }
    @if (slide.row_2) {
      <span class="row2">{{ slide.row_2 }}</span>
    }
    @if (slide.richtext) {
      <span class="richtext" [innerHTML]="slide.richtext | sanitize"></span>
    }
  </div>
}
